module.exports = ".fontAwesome {\n  font-family: 'Helvetica', FontAwesome, sans-serif; }\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/sublocality/sublocality.component.scss
// module id = ./client/app/sublocality/sublocality.component.scss
// module chunks = main